// extracted by mini-css-extract-plugin
module.exports = {"priceOverviewItemList":"PriceOverviewItemList_priceOverviewItemList__19q3z","priceOverviewItem":"PriceOverviewItemList_priceOverviewItem__3uhnQ"};